import qs from 'querystring';

let Vue;

class ApiPlugin {
  constructor(name, baseUrl, requestIntercept = opt => opt) {
    this.name = name;
    this.baseUrl = baseUrl;
    this.requestIntercept = requestIntercept;
  }

  async get(path, options){
    return this.request('GET', path, options);
  }

  async post(path, options){
    return this.request('POST', path, options);
  }

  async put(path, options){
    return this.request('PUT', path, options);
  }

  async delete(path, options){
    return this.request('DELETE', path, options);
  }

  async request(method, path, options = {}) {
    options = await this.requestIntercept(options);
    const queryStr = options.query ? `?${qs.stringify(options.query)}` : '';
    const url = `${this.baseUrl}${path}${queryStr}`;
    options.method = method;
    return fetch(url, options).then(res => res.json());
  }

  // Vue specific code required to hide away 'installing' the broker functionality on the Vue prototype
  install(_Vue) {
    if (Vue && _Vue === Vue) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(
          '[broker] already installed. Vue.use(MessageBroker) should be called only once.'
        );
      }
      return;
    }
    Vue = _Vue;
    Vue.prototype[`$${this.name}`] = this;
  }
}

export default ApiPlugin;
